import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayCount'
})
export class ArrayCountPipe implements PipeTransform {

  transform(value: string, matchValue: string): number {
    if (!value) {
      return 0;
    }
    return value.split(matchValue)?.length;
  }
}